import { captureException } from '@sentry/react'
import { ErrorKeys } from 'consts/errorKeys'
import { IMediaFile } from 'store/features/projectData/thunks/media'
import { withAppThunks } from 'store/with-app-thunks'
import { TAppDispatch } from 'store/types'
import { handleApiError } from 'store/utils'
import { IUploadMediaItem } from 'types/media'
import { convertMediaFilesToReferenceImages } from 'utils/aiImage'
import { ApiError, ReduxThunkError } from 'utils/errors'

/**
 * Thunk to upload reference images to the project
 * @param medias - The reference images to upload
 */
const uploadRefImages = (medias: IUploadMediaItem[]) =>
  withAppThunks(appThunks => async (dispatch: TAppDispatch) => {
    try {
      const uploadedMedias = (await dispatch(
        appThunks.projectDataThunks.uploadMedias(medias)
      )) as IMediaFile[]

      // Convert uploaded media to reference image format
      const preparedMedias = convertMediaFilesToReferenceImages(
        uploadedMedias.map(media => ({
          ...media,
          id: Number(media.id)
        }))
      )

      // Add new reference images to existing ones
      dispatch(appThunks.aiImageThunks.addReferenceImage(preparedMedias))
    } catch (error) {
      if (!(error instanceof ApiError)) {
        captureException(new ReduxThunkError(error))
      }
      dispatch(handleApiError(ErrorKeys.GENERAL_API_ERROR))
    }
  })

export const uploadThunks = {
  uploadRefImages
}
